import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { ActivityTabs, buttonTypes, PropertyType } from '../../constants/commonenums';
import { ButtonValue } from '../../dynamicform/models/common-models';
import { GuestService } from '../../services/guest.service';
import _ from 'lodash';
import { Subscription } from 'rxjs';
import { Utilities } from 'src/app/shared/utilities/utilities';

@Component({
    selector: 'app-cart-tems-popup',
    templateUrl: './cart-tems-popup.component.html',
    styleUrls: ['./cart-tems-popup.component.scss'],
    standalone: false
})
export class CartTemsPopupComponent implements OnInit, OnDestroy {
  DataGridList: any;
  buttonValueProceed: ButtonValue;
  buttonValueClose: ButtonValue;
  cartSumaryDataList = [];
  subscriptions: Subscription = new Subscription();
  columns = [[
    { field: 'select', header: 'select', style: { 'width': '8%' }, isSelect: true },
    { field: 'PartyName', header: 'PartyName', style: { 'width': '20%' } },
    { field: 'Size', header: 'PartySize', style: { 'width': '10%' } },
    { field: 'StartDate', header: 'ReservationDate', style: { 'width': '20%' }, isDate: true },
    { field: 'SpecialMeal', header: 'SpecialMealName', style: { 'width': '17%' }, alignRight: true },
    { field: 'Amount', header: 'Payment', style: { 'width': '10%' }, alignRight: true, isCurrency: true },
    { field: 'status', header: 'Status', style: { 'width': '10%' }, alignRight: true },
    { field: 'Action', header: 'Action', style: { 'width': '10%' }, alignRight: true, isAction: true },
  ], [{ field: 'select', header: 'select', style: { 'width': '5%' }, isSelect: true },
  { field: 'PartyName', header: 'PartyName', style: { 'width': '15%' } },
  { field: 'SpecialMeal', header: 'ActivityName', style: { 'width': '15%' } },
  { field: 'Size', header: 'GroupSize', style: { 'width': '10%' }, alignRight: true },
  { field: 'StartDate', header: 'ReservationDate', style: { 'width': '20%' }, isDate: true },
  { field: 'TotalSessions', header: 'No.Of Sessions', style: { 'width': '10%' }, alignRight: true },
  { field: 'Amount', header: 'Charge', style: { 'width': '10%' }, alignRight: true, isCurrency: true },
  { field: 'status', header: 'Status', style: { 'width': '10%' }, alignRight: true },
  { field: 'Action', header: 'Action', style: { 'width': '10%' }, alignRight: true, isAction: true },]];
  cols = [];
  columnsToDisplay: any;
  constructor(public dialogRef: MatDialogRef<CartTemsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData,
    public gs: GuestService, public ts: TranslateService
  ) {
    const propType = this.gs.restaurantWidgetSettings$.value.PropertyType;
    if (Utilities.IsActivitiesVenues(propType)) {
      this.cols = this.columns[1];
    } else {
      this.cols = this.columns[0];
    }
    // this.cartSumaryDataList = _.cloneDeep(this.gs.TotalCartBookingList);
    this.cartSumaryDataList.forEach(data => {
      data['PartyName'] = data.Contact.FirstName + ' ' + data.Contact.LastName
      data['SpecialMeal'] = data.SpecialMealId ? data.SpecialMealId : 'NA';
      data['TotalSessions'] = !data.SpecialMealId ? data.Slots?.length : data.Sessions.Sessions?.length;
    });
    this.DataGridList = new MatTableDataSource<any>(this.cartSumaryDataList);
  }

  ngOnInit(): void {
    this.columnsToDisplay = this.cols.map(x => {
      return x.field;
    })
    this.buttonValueProceed = {
      type: buttonTypes.actionPrimary,
      label: this.ts.instant('proceed'),
      customclass: 'next-btn',
      disbaledproperity: true
    }
    this.buttonValueClose = {
      type: buttonTypes.actionPrimary,
      label: this.ts.instant('Close'),
      customclass: 'next-btn',
    }

  }



  onSelectRow(event, data) {
    const selected = this.DataGridList.data.find(element => element['isSelected']);
    this.buttonValueProceed.disbaledproperity = selected < 0
  }

  editItem(data) {
    this.getPartyInfo(data);
    if (data.SpecialMealId) {
      this.gs.bookingSection$.next(false);
      this.gs.TabChange$.next(ActivityTabs.ActivitySelection);
    } else {
      this.gs.bookingSection$.next(true);
      this.gs.TabChange$.next(ActivityTabs.BookingSelection);
    }
    this.dialogRef.close();
  }

  removeItem(data, index) {
    this.cartSumaryDataList.splice(index, 1);
    this.DataGridList = new MatTableDataSource<any>(this.cartSumaryDataList);
    this.gs.cartCount = this.cartSumaryDataList.length;
    this.gs.deleteCartItem(data.Id).subscribe(data => {
      this.gs.setMessageState('Reservation removed Successfully', 1)
    });
  }

  getPartyInfo(data) {
    this.subscriptions.add(this.gs.getByToken(data.token, '', 0).subscribe(data => {
      this.gs.editPartyData.next(data);
    }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }
}
